// A reducer to flag whether a fetch query is in progress or has finished or not
const fetchingReducer = (state = {}, action) => {
  const { type, payload } = action

  // Assume all matches end with one of these three
  const matchQuery = /FETCH_(.*)_(BEGIN|SUCCESS|FAILURE)/
  const matches = matchQuery.exec(type)

  // If it's not a fetching action, then dump it
  if (!matches) return state

  const [, actionName, actionState] = matches

  // We want to store the fetch status flag as fetching_<<data name>>: Boolean state
  let newState = {
    ...state,
    // Returns whether this is fetching or if we've finished
    [`fetching_${actionName.toLowerCase()}`]: actionState === "BEGIN"
  }

  // Store the error as error_<<data name>>: String
  if (actionState === "FAILURE") {
    newState[`error_${actionName.toLowerCase()}`] = payload.message
  }

  return newState
}

export default fetchingReducer
